import { AxiosInstance } from "axios";
import { CrudService } from "./crudService";
import { IDelegateRole } from "../interfaces/IDelegateRole";

export class DelegateRoleService extends CrudService<IDelegateRole> {
    constructor(apiClient: AxiosInstance) {
        super(apiClient, '/admin/delegate-role');
    }
}